import { render, staticRenderFns } from "./PropertiesScroll.vue?vue&type=template&id=0cdd782c&scoped=true&"
import script from "./PropertiesScroll.vue?vue&type=script&lang=js&"
export * from "./PropertiesScroll.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesScroll.vue?vue&type=style&index=0&id=0cdd782c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd782c",
  null
  
)

export default component.exports